var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"error-500-content-component"},[_c('b-col',{attrs:{"lg":"12"}},[_c('h1',{staticClass:"error-title"},[_vm._v("Repairs are in progress")]),_vm._v(" "),_c('p',[_vm._v("This website is currently down for maintance. Soon we will be back and working again. Thanks for your patience.")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00f6ddbc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/503/Error503Content.vue
// module id = DRWM
// module chunks = 0